<script>
export default {
    name: 'IconBrandLogoFavicon',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-brand-logo-favicon"
        viewBox="0 0 88 102"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" d="M0 102L88 102 88 0 0 0z" />
        <path
            fill="#FFF"
            d="M43.994 19C54.49 19 63 27.76 63 38.552V82H49.273V64.618H38.719V82H25V38.552C25 27.76 33.501 19 43.994 19m0 14.117c-2.914 0-5.275 2.439-5.275 5.435v13.034h10.554V38.552c0-2.996-2.363-5.435-5.279-5.435"
        />
    </svg>
</template>
